import type { ReactNode } from 'react';

export const symbol_vertical_align_center: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m450-282-64 64q-8.56 9-21.78 9T342-218q-9-9-9-22.22 0-13.22 9-21.78l117-117q5-5 10.13-7 5.14-2 11-2 5.87 0 10.87 2 5 2 10 7l117 117q9 8.56 9 21.78T618-218q-9 9-22.22 9-13.22 0-21.78-9l-64-64v172q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q450-97.25 450-110v-172ZM190-450q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h580q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H190Zm260-228v-172q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v172l64-64q8.56-9 21.78-9t22.22 9q9 9 9 22.22 0 13.22-9 21.78L501-581q-5 5-10.13 7-5.14 2-11 2-5.87 0-10.87-2-5-2-10-7L342-698q-9-8.56-9-21.78t9-22.22q9-9 22.22-9 13.22 0 21.78 9l64 64Z"
		/>
	</svg>
);
